import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sky-mobile-nav',
  templateUrl: './sky-mobile-nav.component.html',
  styleUrls: ['./sky-mobile-nav.component.scss']
})
export class SkyMobileNavComponent implements OnInit {

  @Input() scope;
  menuOpen = false;

  constructor() { }

  ngOnInit(): void { }

  openMenu(): void { this.menuOpen = true; }
  closeMenu(): void { this.menuOpen = false; }
}
